import { FC, useMemo } from "react";

import { SessionStatsCard } from "./SessionStatsCard";

import { t } from "i18n/i18n";
import { FlagIcon, HandRaiseOutlineIcon } from "mds/icons";
import { useCapabilities } from "store/capability-hooks";
import { useAppSelector } from "store/index";
import {
  selectCurrentSectionId,
  selectExtendedClassSessionSummariesForDateRange,
} from "store/selectors";
import { computeAttendanceStats } from "utils/metrics-utils";

type AttendanceCardProps = {
  dateRangeValue: number;
};

export const AttendanceCard: FC<AttendanceCardProps> = ({ dateRangeValue }) => {
  const sectionId = useAppSelector(selectCurrentSectionId);
  const classSessions = useAppSelector((state) =>
    selectExtendedClassSessionSummariesForDateRange(state, dateRangeValue),
  );
  const { canAuthorSection } = useCapabilities();

  const { averageAttendance, highestAttendance } = useMemo(
    () => computeAttendanceStats(classSessions),
    [classSessions],
  );

  if (!canAuthorSection || !sectionId) return null;

  const isEmpty = classSessions.length === 0;
  const highestText = highestAttendance.date
    ? t("session_log_view.stats.attendance.highest", highestAttendance)
    : t("session_log_view.stats.attendance.no_sessions");

  return (
    <SessionStatsCard
      FooterIcon={FlagIcon}
      footerText={highestText}
      isEmpty={isEmpty}
      kind="attendance"
      title={t("session_log_view.stats.attendance.title")}
      TitleIcon={HandRaiseOutlineIcon}
      value={isEmpty ? 0 : `${averageAttendance}%`}
      valueDescription={t("session_log_view.stats.attendance.value_description")}
    />
  );
};
